import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewFilmFestivalHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Film Festival</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 2 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the "Film Festivals" link. This will take you to the Film Festivals Listing Page.<br />
                                    <img src="/img/documentation-img/FilmImg/nav.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Film Festivals Listing Page, there is a search bar for you to filter the film festival listings. Type the search string in the text box and click “Search”. <br />
                                    <img src="/img/documentation-img/FilmImg/list_search.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Film Festivals Listing Page, click on any film festival of your choice. This will take you to the View Film Festivals Details.<br />
                                    <img src="/img/documentation-img/FilmImg/list_select.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In Film Festivals Details Page, you will be able to see the following fields:
                                    <ul class="unorderedList">
                                        <li>
                                            Film Festival Title
                                        </li>
                                        <li>Film Festival Code</li>
                                        <li>
                                            Display Start DateTime
                                        </li>
                                        <li>
                                            Display End DateTime
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Film Festival Description
                                        </li>
                                        <li>
                                            Festival Image
                                        </li>
                                        <li>
                                            Film Festival Programmes
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start DateTime should always be earlier than Display End DateTime.<br />
                                            - Film Festival Description should be in HTML format.
                                </div>
                            </li>

                            </ol>
                            <div className="text-right">
                                <a href="/documentation/filmfestivals/CreateFilmFestivalHelp" className="btn btn-primary">Create Film Festival &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}